// extracted by mini-css-extract-plugin
export default {"inputField":"outlined-textarea_inputField__yqab3","fullWidth":"outlined-textarea_fullWidth__PCkRr","error":"outlined-textarea_error__y2u3X"};